const userPhotos = document.querySelectorAll('.user-photo__list li');
const userPhotoModal = document.querySelector('.user-photo-modal');
const userPhotoModalCloseBtn = document.querySelector('.user-photo-modal__close-button');
const userPhotoModalOverlay = document.querySelector('.user-photo-modal__overlay');

// モーダルを開く
const openModal = index => {
  userPhotoModal.classList.add('opened');
  document.addEventListener('keydown', handleEscClose);

  // クリックした写真をモーダルに表示する
  const userPhotoModalContents = document.querySelectorAll('.user-photo-modal__content-inner');
  const currentDisplayPhoto = document.querySelector('.user-photo-modal__content-inner.current');
  currentDisplayPhoto.classList.remove('current');
  userPhotoModalContents[index].classList.add('current');
};
// モーダルを閉じる
const closeModal = () => {
  userPhotoModal.classList.remove('opened');
  document.removeEventListener('keydown', handleEscClose);
};
// エスケープキーでモーダルを閉じる
const handleEscClose = evt => {
  if (evt.key === 'Escape') {
    closeModal();
  }
};

// ユーザーフォトをクリックした時
userPhotos.forEach((photo, index) => {
  // モーダルを開く
  photo.addEventListener('click', () => {
    openModal(index);
  });
});

// モーダルの閉じるボタン・オーバーレイをクリックした時、モーダルを閉じる
userPhotoModalCloseBtn.addEventListener('click', closeModal);
userPhotoModalOverlay.addEventListener('click', closeModal);

const userPhotoPrev = document.querySelector('.user-photo-modal__nav-prev');
const userPhotoNext = document.querySelector('.user-photo-modal__nav-next');
const userPhotoPrevSp = document.querySelectorAll('.user-photo-modal__content-image-prev-sp');
const userPhotoNextSp = document.querySelectorAll('.user-photo-modal__content-image-next-sp');

// モーダル内の写真を前に切り替える
function switchToPrevPhoto() {
  const currentDisplayPhoto = document.querySelector('.user-photo-modal__content-inner.current');
  const prevDisplayPhoto = currentDisplayPhoto.previousElementSibling;
  // 前の写真が無い場合は、最後の写真を表示する
  if (prevDisplayPhoto === null) {
    const lastDisplayPhoto = document.querySelector('.user-photo-modal__content-inner:last-child');
    lastDisplayPhoto.classList.add('current');
    currentDisplayPhoto.classList.remove('current');
    return;
  }
  prevDisplayPhoto.classList.add('current');
  currentDisplayPhoto.classList.remove('current');
}

// モーダル内の写真を次に切り替える
function switchToNextPhoto() {
  const currentDisplayPhoto = document.querySelector('.user-photo-modal__content-inner.current');
  const nextDisplayPhoto = currentDisplayPhoto.nextElementSibling;
  // 次の写真が無い場合は、最初の写真を表示する
  if (nextDisplayPhoto === null) {
    const firstDisplayPhoto = document.querySelector(
      '.user-photo-modal__content-inner:first-child'
    );
    firstDisplayPhoto.classList.add('current');
    currentDisplayPhoto.classList.remove('current');
    return;
  }
  nextDisplayPhoto.classList.add('current');
  currentDisplayPhoto.classList.remove('current');
}

// クリックした時にコンテンツを切り替える
userPhotoPrev.addEventListener('click', switchToPrevPhoto);
userPhotoPrevSp.forEach(sp => {
  sp.addEventListener('click', switchToPrevPhoto);
});
userPhotoNext.addEventListener('click', switchToNextPhoto);
userPhotoNextSp.forEach(sp => {
  sp.addEventListener('click', switchToNextPhoto);
});
